/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { userInvitesActions } from './slice';
import API from './constants';
/**
 * Get user invites generator function to get all user invites
 * @param {*} param0
 */
export function* getUserInvitesGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_USER_INVITES, payload);
    yield put(userInvitesActions.getUserInvitesSucceeded(response));
  } catch (error) {
    yield put(userInvitesActions.getUserInvitesFailed(error?.message));
  }
}
/**
 * Users list generator function to get users list
 * @param {*} param0
 */
export function* usersListGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_USER_LIST, payload);
    yield put(userInvitesActions.usersListSucceeded(response));
  } catch (error) {
    yield put(userInvitesActions.usersListFailed(error?.message));
  }
}
/**
 * Get roles generator function to get roles
 * @param {*} param0
 */
export function* getRolesGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ROLES, payload);
    yield put(userInvitesActions.getRolesSucceeded(response));
  } catch (error) {
    yield put(userInvitesActions.getRolesFailed(error?.message));
  }
}
/**
 * Resend invite generator function to resend user invitation
 * @param {*} param0
 */
export function* resendInviteGenerator({ payload }) {
  try {
    const response = yield call(request, API.REINVITE_USER, payload);
    yield put(userInvitesActions.resendInviteSucceeded(response));
  } catch (error) {
    yield put(userInvitesActions.resendInviteFailed(error?.message));
  }
}
//
export function* userInvitesSaga() {
  yield takeLatest(userInvitesActions.getUserInvites.type, getUserInvitesGenerator);
  yield takeLatest(userInvitesActions.usersList.type, usersListGenerator);
  yield takeLatest(userInvitesActions.getRoles.type, getRolesGenerator);
  yield takeLatest(userInvitesActions.resendInvite.type, resendInviteGenerator);
}
//
export default userInvitesSaga;
